import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editArea = ( {data, areaId} : {data: IPostEditArea | {}, areaId: number}): Promise<string> => {
  return axiosDefaultApi.put(`/api/Areas/UpdateArea/${areaId}`, data);
};

type QueryFnType = typeof editArea;

type UseEditAreaOptions = {
  data: IPostEditArea | {};
  areaId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditArea = ({ config }: UseEditAreaOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Περιοχής.`, 500);
            console.error('Couldnt edit Area', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllAreas"])
            addNotification('Η Περιοχή Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editArea,
    })
}